import { lastValueFrom } from "rxjs";

import StorefrontValuesGrowaveApiService from "../api_services/StorefrontValuesGrowaveApiService";
import type { SelectValueParamsWithoutSchema } from "../types";

class GrowaveApiStrategy {
    constructor(
        private readonly storefrontValuesGrowaveApiService: StorefrontValuesGrowaveApiService
    ) {}

    public getValue(params: SelectValueParamsWithoutSchema): Promise<unknown> {
        return lastValueFrom(
            this.storefrontValuesGrowaveApiService.selectStorefrontValues(
                params
            )
        );
    }
}

export default GrowaveApiStrategy;
